import { motion } from "framer-motion";
import { Footprints, BadgeCheck, Sparkles } from "lucide-react";

const STEPS = [
  { icon: Footprints, t: "Book online", d: "Pick a service, a day and a slot. Takes under a minute. No payment yet." },
  { icon: BadgeCheck, t: "Free walkthrough", d: "We visit your property in person and see exactly what it needs. No two cleans are alike, so no two quotes are either." },
  { icon: Sparkles, t: "Your price, then we handle it", d: "You get a tailored quote for your space. Approve it and we take it from there." },
];

export const Pricing = () => (
  <section className="relative border-y border-white/10 bg-[#0D0E11]" data-testid="pricing-section">
    <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-28">
      <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <h2 className="font-display text-5xl uppercase leading-[0.9] text-zinc-50 sm:text-7xl">
          Priced like <br /><span className="font-serif-i normal-case text-acid">it&apos;s personal.</span>
        </h2>
        <p className="max-w-sm text-base text-zinc-400">Because it is. A studio isn&apos;t a showroom isn&apos;t a five-bedroom. Flat-rate guesswork would just be lying with extra steps.</p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <motion.div key={s.t} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="border border-white/10 bg-[#111317] p-8 transition-colors duration-500 hover:border-white/25 sm:p-10" data-testid={`pricing-step-${i + 1}`}>
            <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[var(--acid)]/40 text-[var(--acid)]">
              <s.icon className="h-5 w-5" />
            </span>
            <p className="mt-8 font-display text-3xl uppercase leading-none text-zinc-50">{s.t}</p>
            <p className="mt-4 text-sm leading-relaxed text-zinc-400">{s.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
